/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Polygon, Line, Polyline } from 'react-native-svg';

import { IconProps } from '../lib';

function BluetoothSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Polygon
        points="119.971 32.003 183.971 80.003 119.971 128.003 119.971 32.003"
        opacity={0.2}
      />
      <Polygon
        points="119.971 128 183.971 176 119.971 224 119.971 128"
        opacity={0.2}
      />
      <Line
        x1={56}
        y1={176.00256}
        x2={120}
        y2={128.00256}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={48.00586}
        y1={40}
        x2={208.00586}
        y2={216}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="120 71.622 120 32.003 184 80.003 150.476 105.146"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Polyline
        points="176.654 181.512 120 224.003 120 128.003 145.169 146.879"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default BluetoothSlash;
